import React from "react";
import { FaQuestion } from "react-icons/fa";

const ConfirmBox = ({ onBackDrop, onConfirm, onCancel, message }) => {
  return (
    <>
      <div
        onClick={onBackDrop}
        className="bg-black opacity-75 fixed top-0 left-0 h-screen w-screen z-10"
      ></div>
      {/* <div className="confirmbox"> */}
      <div className="bg-primary fixed xs:h-[350px] xs:w-[350px] h-[300px] w-[300px] border border-[#EEEEF0] rounded-[30px] z-20 xs:top-[calc(50%-175px)] xs:left-[calc(50%-175px)] top-[calc(50%-150px)] left-[calc(50%-150px)]">
        <div className="flex flex-col justify-center items-center w-full h-full xs:gap-12 gap-6 xs:p-10 p-5">
          <div className="flex items-center justify-center xs:w-[88px] xs:h-[88px] w-[70px] h-[70px] bg-[#4B5548] rounded-full shadow-lg shadow-black/25">
            <span className="text-primary text-[32px] font-semibold">
              <FaQuestion />
            </span>
          </div>

          <p className="text-textPrimary text-center leading-6 tracking-[0.5px] ">
            Are you sure you want to
            <br /> {message} Exam?
          </p>

          <div className="flex justify-between w-full px-5">
            <button type="button" className="font-bold" onClick={onCancel}>
              No
            </button>
            <button type="button" className="font-bold" onClick={onConfirm}>
              Yes
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmBox;
